import { ChakraBox, ChakraVStack } from '@equip.health/ui';

import Authorizations from '~/components/common/billingPeriods/BillingPeriodAuthorizationsList';
import BillingPeriodDetails from '~/components/common/billingPeriods/BillingPeriodDetails';
import {
  BillingPeriodProps,
  RenderMode,
} from '~/components/common/billingPeriods/types';
import { BILLING_PERIODS_TOP_LEVEL_ID } from '~/lib/constants';
import { getBillingPeriodCoverageInfo } from '~/lib/util/billingPeriod.util';

const BillingPeriodView = ({ billingPeriodState }: BillingPeriodProps) => {
  const { renderMode, updatedBillingPeriod } = billingPeriodState;
  const isReadOnly = renderMode === RenderMode.VIEW;
  const billingPeriodDetails =
    getBillingPeriodCoverageInfo(updatedBillingPeriod);

  return (
    <ChakraBox
      id={`${BILLING_PERIODS_TOP_LEVEL_ID}__view`}
      overflow="auto"
      padding="20px"
    >
      <ChakraVStack alignItems="flex-start" gap="24px" paddingBottom="50px">
        <BillingPeriodDetails
          billingPeriodDetails={billingPeriodDetails}
          isReadOnly={isReadOnly}
          showRequiredFieldErrors={false}
        />
        <Authorizations
          authorizations={updatedBillingPeriod?.authorizationDetails}
          billingPeriodState={billingPeriodState}
          isAuthorizationRequired={updatedBillingPeriod?.isAuthRequired}
          isReadOnly={isReadOnly}
          showRequiredFieldErrors={false}
        />
      </ChakraVStack>
    </ChakraBox>
  );
};

export default BillingPeriodView;
